<template>
  <section>
    <errors v-if="isVisibleErrorsModal"></errors>
    <commercial-address-override
      v-if="isCommercialOverrideModalVisible"
      @confirm="confirmCommercialOverride"
      @cancel="cancelCommercialOverride"></commercial-address-override>
    <address-suggestion v-if="isSuggestedAddressModalVisible"></address-suggestion>

    <div class="content-wrapper">
      <div class="content-heading">
        Create user
        <small data-localize="dashboard.WELCOME"></small>
      </div>

      <button type="button" class="btn-back icon-back bottom-margin" v-on:click="goBack()">Go back</button>

      <div class="row">
        <spinner v-if="disableSubmit"></spinner>
        <div class="col-lg-12">

          <div id="panelChart9" class="panel panel-default">
            <div v-if="$route.query.retry" class="alert alert-warning" role="alert">
              <h4><em class="icon-exclamation pr-sm"></em>There was an issue validating your personal information.</h4>
              <p>Please verify your information and submit it once more.</p>
            </div>

            <p><strong class="text-info">*</strong><small> Required fields</small></p>

            <div class="panel-title">
              User information
            </div>
            <div class="line-separator"></div>

            <div class="row bottom-margin">
              <div class="col-md-4">
                <div v-bind:class="newUser.userType === 'INVESTOR' ? 'radio-item' : 'radio-item radio-item-unselected'">
                  <input type="radio" name="InvestorOption" id="InvestorOption" v-model="newUser.userType" value="INVESTOR" />
                  <label for="InvestorOption">Investor</label>
                </div>
              </div>
              <div class="col-md-4">
                <div v-bind:class="newUser.userType === 'ADVISOR' ? 'radio-item' : 'radio-item radio-item-unselected'">
                  <input type="radio" name="FinancialAdvisorOption" id="FinancialAdvisorOption" v-on:click="selectAdvisor()" v-model="newUser.userType" value="ADVISOR" />
                  <label for="FinancialAdvisorOption">Financial Advisor </label>
                </div>
              </div>
            </div>
            <div class="row bottom-margin">
              <div class="col-md-4">
                <div v-bind:class="newUser.userType === 'MINOR' ? 'radio-item' : 'radio-item radio-item-unselected'">
                  <input type="radio" name="MinorOption" id="MinorOption" v-model="newUser.userType" value="MINOR" />
                  <label for="MinorOption">Minor</label>
                </div>
              </div>
              <div class="col-md-4">
                <div v-bind:class="newUser.userType === 'ADMIN' ? 'radio-item' : 'radio-item radio-item-unselected'">
                  <input type="radio" name="AdminOption" id="AdminOption" v-on:click="selectAdmin()" v-model="newUser.userType" value="ADMIN" />
                  <label for="AdminOption">Admin </label>
                </div>
              </div>
            </div>
             <div class="row bottom-margin">
              <div class="col-md-4">
                <div v-bind:class="newUser.userType === 'INSTITUTIONAL_REPRESENTATIVE' ? 'radio-item' : 'radio-item radio-item-unselected'">
                  <input type="radio" name="institutionalRepresentative" id="institutionalRepresentative" v-model="newUser.userType" value="INSTITUTIONAL_REPRESENTATIVE" />
                  <label for="institutionalRepresentative">Institutional Representative </label>
                </div>
              </div>
              <div class="col-md-4">
                <div v-bind:class="newUser.userType === 'READ_ONLY' ? 'radio-item' : 'radio-item radio-item-unselected'">
                  <input type="radio" name="readOnlyOption" id="readOnlyOption" v-model="newUser.userType" value="READ_ONLY" />
                  <label for="readOnlyOption">Read-only</label>
                </div>
              </div>
            </div>
            <div class="line-separator"></div>

            <div class="row top-margin">
              <div class="col-md-6">
                <div class="form-group">
                  <label for="address">First name <strong class="text-info">*</strong></label>
                  <input type="text" name="FirstName" id="FirstName" v-model="newUser.firstName" placeholder="First name" :class="{ 'form-control': true, 'form-control-error': errors.has('FirstName') }" v-validate="{required: true}" />
                  <span v-if="errors.has('FirstName')" class="error-feedback">Required</span>
                </div>
              </div>
              <div class="col-md-6">
                <div class="form-group">
                  <label for="address">Last name <strong class="text-info">*</strong></label>
                  <input type="text" name="LastName" id="LastName" v-model="newUser.lastName" placeholder="Last name" :class="{ 'form-control': true, 'form-control-error': errors.has('LastName') }" v-validate="{required: true}" />
                  <span v-if="errors.has('LastName')" class="error-feedback">Required</span>
                </div>
              </div>
            </div>
            <div class="row" v-if="newUser.userType=='ADVISOR'">
              <div class="col-md-6">
                <div class="form-group">
                  <label for="address">Company name 1 <strong class="text-info">*</strong></label>
                  <input type="text" name="CompanyName1" id="CompanyName1" v-model="newUser.organizationName" placeholder="Company name" :class="{ 'form-control': true, 'form-control-error': errors.has('CompanyName1') }" v-validate="{required: true}" />

                  <span v-if="errors.has('CompanyName1')" class="error-feedback">Required</span>
                </div>
              </div>
              <div class="col-md-6">
                <div class="form-group">
                  <label for="address">Company name 2</label>
                  <input type="text" name="CompanyName2" id="CompanyName2" v-model="newUser.alternateCompanyName" placeholder="Company name" :class="{ 'form-control': true, 'form-control-error': errors.has('CompanyName2') }" />
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-6" v-if="newUser.userType==='ADMIN'">
                <div class="form-group">
                  <label for="address">Company name</label>
                  <input type="text" name="CompanyName" id="CompanyName" v-model="newUser.organizationName" class="form-control" value="Calvert Impact Capital">
                </div>
              </div>
              <div :class="{ 'col-md-12': true, 'col-md-6': newUser.userType==='ADMIN' }" v-if="newUser.userType==='ADMIN' || newUser.userType==='ADVISOR'">
                <div class="form-group">
                  <label for="address">Email <strong class="text-info">*</strong></label>
                  <div class="availability-check-container">
                    <input
                      type="text"
                      name="Email"
                      id="Email"
                      v-model="newUser.email"
                      placeholder="Email"
                      :class="{ 'form-control': true, 'form-control-error': errors.has('Email') }"
                      @input="emailInput"
                      @blur="checkEmailAvailability"
                    />
                    <div class="availability-indicator" v-if="emailAvailabilityStatus !== null">
                      <span v-if="emailAvailabilityStatus === 'checking'" class="fa fa-spinner fa-spin text-info"></span>
                      <span v-if="emailAvailabilityStatus === 'available'" class="fa fa-check text-success"></span>
                      <span v-if="emailAvailabilityStatus === 'unavailable'" class="fa fa-times text-danger"></span>
                    </div>
                  </div>
                  <span v-if="errors.has('Email')" class="error-feedback">{{ errors.first('Email') }}</span>
                </div>
              </div>
              <div class="col-md-6" v-show="newUser.userType==='ADVISOR'">
                <div class="form-group">
                  <label for="address">CRD number</label>
                  <input type="text" name="CRD" id="CRD" placeholder="CRD NUMBER" v-model="newUser.CRDnumber" :class="{ 'form-control': true, 'form-control-error': errors.has('CRD') }" />
                  <span v-if="errors.has('CRD')" class="error-feedback">Required</span>
                </div>
              </div>
            </div>
            <div class="row" v-show="newUser.userType === 'INVESTOR' || newUser.userType === 'MINOR' || newUser.userType === 'INSTITUTIONAL_REPRESENTATIVE' || newUser.userType === 'READ_ONLY'">
              <div class="col-md-6">
                <label for="date-time-input">Date of birth</label>
                <div class="form-group input-group date birth-field-bottom">
                  <date-picker placeholder="mm/dd/yyyy" v-model="newUser.dateOfBirth" id="date-time-input" name="date-time-input" :wrap="true" :config="dateBirthConfig" :class="{ 'form-control': true, 'form-control-error': isBirthFieldInvalid }"
                    @blur.native="checkDateBirth(newUser.dateOfBirth)">
                  </date-picker>
                  <div class="input-group-addon">
                    <span class="fa fa-calendar"></span>
                  </div>
                </div>
                <span v-if="isBirthFieldInvalid" class="error-feedback">Required</span>
              </div>

              <div class="col-md-6">
                <div class="form-group">
                  <label for="ssn">Social security number</label>
                  <div class="availability-check-container">
                    <input
                      type="text"
                      name="ssn"
                      id="ssn"
                      v-model="newUser.socialSecurityNum"
                      placeholder="000-00-0000"
                      :class="{ 'form-control': true }"
                      v-mask="'999-99-9999'"
                      @input="ssnInput"
                      @blur="checkSsnAvailability"
                    />
                    <div class="availability-indicator" v-if="ssnAvailabilityStatus !== null">
                      <span v-if="ssnAvailabilityStatus === 'checking'" class="fa fa-spinner fa-spin text-info"></span>
                      <span v-if="ssnAvailabilityStatus === 'available'" class="fa fa-check text-success"></span>
                      <span v-if="ssnAvailabilityStatus === 'unavailable'" class="fa fa-times text-danger"></span>
                    </div>
                  </div>
                  <span v-if="errors.has('ssn')" class="error-feedback">{{ errors.first('ssn') }}</span>
                </div>
              </div>
            </div>

            <div class="row" v-show="newUser.userType==='INVESTOR' || newUser.userType === 'MINOR' || newUser.userType === 'INSTITUTIONAL_REPRESENTATIVE' || newUser.userType === 'READ_ONLY'">
              <div class="col-md-6">
                <div class="form-group">
                  <label for="address">Primary email <strong class="text-info" v-if="emailRequired">*</strong></label>
                  <div class="availability-check-container">
                    <input
                      type="text"
                      name="PrimaryEmail"
                      id="PrimaryEmail"
                      v-model="newUser.email"
                      placeholder="Primary email"
                      :class="{ 'form-control': true, 'form-control-error': errors.has('PrimaryEmail') }"
                      @input="emailInput"
                      @blur="checkEmailAvailability"
                    />
                    <div class="availability-indicator" v-if="emailAvailabilityStatus !== null">
                      <span v-if="emailAvailabilityStatus === 'checking'" class="fa fa-spinner fa-spin text-info"></span>
                      <span v-if="emailAvailabilityStatus === 'available'" class="fa fa-check text-success"></span>
                      <span v-if="emailAvailabilityStatus === 'unavailable'" class="fa fa-times text-danger"></span>
                    </div>
                  </div>
                  <span v-if="errors.has('PrimaryEmail')" class="error-feedback">{{ errors.first('PrimaryEmail') }}</span>
                </div>
              </div>
              <div class="col-md-6">
                <div class="form-group">
                  <label for="address">Secondary email</label>
                  <input type="text" name="SecondaryEmail" id="SecondaryEmail" v-model="newUser.secondaryEmail" placeholder="Secondary Email" :class="{ 'form-control': true, 'form-control-error': errors.has('SecondaryEmail') }" />
                  <span v-if="errors.has('SecondaryEmail')" class="error-feedback">{{ errors.first('SecondaryEmail') }}</span>
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col-md-6">
                <div class="form-group">
                  <label for="primaryPhoneNum">Primary phone number <strong class="text-info">*</strong></label>
                  <input id="primaryPhoneNum" name="primaryPhoneNum" v-model="newUser.primaryPhoneNum" placeholder="Phone number" :class="{ 'form-control': true, 'form-control-error': errors.has('primaryPhoneNum') }" v-validate="'required'" v-mask="'(999) 999-9999'" @input="onPhoneNumberChange"
                  />

                  <span v-if="errors.has('primaryPhoneNum')" class="error-feedback">Required</span>
                </div>
              </div>

              <div class="col-md-6">
                <div class="form-group">
                  <label for="ssn">Secondary phone number</label>
                  <input v-model="newUser.secondaryPhoneNum" class="form-control" type="text" id="spn" v-mask="'(999) 999-9999'" @input="onPhoneNumberChange" />
                </div>
              </div>
            </div>

            <div v-if="enableMfa" class="row top-margin">
              <div class="col-md-12">
                <div class="form-group">
                  <label for="mfaPhonePreference">
                    <strong>MFA Phone Preference</strong>
                  </label>
                  <select
                    id="mfaPhonePreference"
                    v-model="mfaPhonePreference"
                    class="form-control"
                  >
                    <option :value="null">-- Select --</option>
                    <option value="PRIMARY" :disabled="!hasPrimaryPhone">
                      Primary Phone
                    </option>
                    <option value="SECONDARY" :disabled="!hasSecondaryPhone">
                      Secondary Phone
                    </option>
                    <option value="NONE">None (Email only)</option>
                  </select>
                  <small class="form-text text-muted">
                    Select which phone number should be used for SMS multi-factor authentication.
                  </small>
                </div>
              </div>
            </div>

            <div v-if="showProvideLoginOption" class="checkbox c-checkbox check-margin">
              <label class="dark-grey-text">
                <input type="checkbox" value="" name="provide-investor-login" v-model="provideInvestorLogin" :disabled="emailIsInvalid">
                <span class="fa fa-check"></span>
                Provide investor log in
              </label>
            </div>
            <div class="checkbox c-checkbox check-margin">
              <label class="dark-grey-text">
                <input type="checkbox" value="" name="enable-mfa" v-model="enableMfa" :disabled="!provideInvestorLogin">
                <span class="fa fa-check"></span>
                Enable MFA
              </label>
            </div>
            <div v-if="showLoginNotice" class="panel-body account-notice">
               <div class="alert alert-info alert-dismissible mt-lg" role="alert">
                <p>
                  <em class="icon-info pr-sm"></em>
                  Normally we do NOT provide minors with a log in.
                </p>
               </div>
            </div>

            <div v-if="newUser.userType === 'INVESTOR' || newUser.userType === 'ADVISOR' || newUser.userType === 'MINOR' || newUser.userType === 'INSTITUTIONAL_REPRESENTATIVE' || newUser.userType === 'READ_ONLY'">
              <div class="panel-title" v-if="newUser.userType=='INVESTOR' || newUser.userType === 'MINOR' || newUser.userType === 'INSTITUTIONAL_REPRESENTATIVE' || newUser.userType === 'READ_ONLY'"> Residential Address </div>
              <div class="panel-title" v-if="newUser.userType=='ADVISOR'"> Business Address </div>
              <div class="line-separator"></div>
            </div>

            <div class="row" v-if="newUser.userType === 'INVESTOR' || newUser.userType === 'ADVISOR' || newUser.userType === 'MINOR' || newUser.userType === 'INSTITUTIONAL_REPRESENTATIVE' || newUser.userType === 'READ_ONLY'">
              <div class="col-md-12">
                <div class="form-group">
                 <RestrictedTwoInputs
                  instructionsLabel="Make sure your address doesn't exceed 50 characters."
                  id="ResidentialAddress"
                  :fieldLabel="streetAddressLabel"
                  primaryPlaceholder="Street and number e.g. 123 Any Street"
                  secondaryPlaceholder="(optional) Apartment, building, floor, etc."
                  :dual="true"
                  :primaryInput="newUser.residentialAddress.streetAddress1"
                  :secondaryInput="newUser.residentialAddress.streetAddress2"
                  @inputUpdated="residentialAddressUpdated"
                 />
                </div>
              </div>
            </div>

            <div class="row" v-if="newUser.userType === 'INVESTOR' || newUser.userType === 'ADVISOR' || newUser.userType === 'MINOR' || newUser.userType === 'INSTITUTIONAL_REPRESENTATIVE' || newUser.userType === 'READ_ONLY'">
              <div class="col-md-3">
                <div class="form-group">
                  <label for="zip-code">Zip code <strong class="text-info" v-if="!isInstitutionalRepresentative">*</strong></label>

                  <input type="text" name="Zipcode" id="Zipcode" v-model="newUser.residentialAddress.zipCode" placeholder="Zip code" :class="{ 'form-control': true, 'form-control-error': errors.has('Zipcode') || isZipCodeInvalid(newUser.residentialAddress.zipCode, newUser.residentialAddress.country) }" v-validate="{required: newUser.userType !== 'INSTITUTIONAL_REPRESENTATIVE' && newUser.userType !== 'READ_ONLY'}"
                  />

                  <span v-if="errors.has('Zipcode') || isZipCodeInvalid(newUser.residentialAddress.zipCode, newUser.residentialAddress.country)" class="error-feedback">Required</span>
                </div>
              </div>

              <div class="col-md-3">
                <div class="form-group">
                  <label for="city">City <strong class="text-info" v-if="!isInstitutionalRepresentative">*</strong></label>

                  <input type="text" name="City" id="City" v-model="newUser.residentialAddress.city" placeholder="City" :class="{ 'form-control': true, 'form-control-error': errors.has('City') }" v-validate="{required: newUser.userType !== 'INSTITUTIONAL_REPRESENTATIVE' && newUser.userType !== 'READ_ONLY'}">

                  <span v-if="errors.has('City')" class="error-feedback">Required</span>
                </div>
              </div>

              <div class="col-md-3">
                <div class="form-group">
                  <label for="pwd">State <strong class="text-info" v-if="!isInstitutionalRepresentative && selectedUserType !== 'READ_ONLY'">*</strong></label>
                  <select id="ResidentialState" name="ResidentialState" v-model="newUser.residentialAddress.state" required :class="{ 'form-control': true, 'form-control-error': errors.has('ResidentialState') }" v-validate="{required: newUser.userType !== 'INSTITUTIONAL_REPRESENTATIVE' && newUser.userType !== 'READ_ONLY'}">
                            <option value="" disabled selected hidden>State</option>
                            <option v-for="s in countryStates('residentialAddress')" :value="s.abbreviation">{{s.name}}</option>
                          </select>
                  <span v-if="errors.has('ResidentialState')" class="error-feedback">Required</span>
                </div>
              </div>

              <div class="col-md-3">
                <div class="form-group">
                  <label for="pwd">Country <strong class="text-info" v-if="!isInstitutionalRepresentative && selectedUserType !== 'READ_ONLY'">*</strong></label>
                    <select id="ResidentialCountry" name="ResidentialCountry" v-model="newUser.residentialAddress.country" required :class="{ 'form-control': true, 'form-control-error': errors.has('ResidentialCountry') }" v-validate="{required: newUser.userType !== 'INSTITUTIONAL_REPRESENTATIVE' && newUser.userType !== 'READ_ONLY'}">
                      <option value="" disabled selected hidden>Country</option>
                      <option v-for="c in geoLocation.countries" :value="c.abbreviation">{{c.name}}</option>
                    </select>
                  <span v-if="errors.has('ResidentialCountry')" class="error-feedback">Required</span>
                </div>
              </div>


            </div>

            <fieldset class="checkbox c-checkbox check-margin mt-xl mb-lg" v-if="newUser.userType=='INVESTOR'  || newUser.userType === 'MINOR' || newUser.userType=='ADVISOR' || newUser.userType === 'INSTITUTIONAL_REPRESENTATIVE' || newUser.userType === 'READ_ONLY'">
              <label>
                <input type="checkbox" value="" name="isResidentDefaultAddress"
                  v-model="isResidentDefaultAddress" v-on:click="submitDifferentMailingAddress()">
                <span class="fa fa-check">
                </span>Different mailing address
              </label>
            </fieldset>

           <fieldset class="mailing-address mb-xl" :hidden="!isResidentDefaultAddress">
            <div v-if="newUser.userType=='INVESTOR'  || newUser.userType === 'MINOR' || newUser.userType=='ADVISOR' || newUser.userType === 'INSTITUTIONAL_REPRESENTATIVE' || newUser.userType === 'READ_ONLY'">
              <div class="panel-title">Mailing Address</div>
              <div class="line-separator"></div>
            </div>

            <div class="row" v-if="newUser.userType === 'INVESTOR' || newUser.userType === 'ADVISOR' || newUser.userType === 'MINOR' || newUser.userType === 'INSTITUTIONAL_REPRESENTATIVE' || newUser.userType === 'READ_ONLY'">
              <div class="col-md-12 top-margin">
                <div class="form-group">
                  <RestrictedTwoInputs
                  instructionsLabel="Make sure your address doesn't exceed 50 characters."
                  id="MailinglAddress"
                  :fieldLabel="streetAddressLabel"
                  primaryPlaceholder="Street and number e.g. 123 Any Street"
                  secondaryPlaceholder="(optional) Apartment, building, floor, etc."
                  :dual="true"
                  :primaryInput="newUser.mailingAddress.streetAddress1"
                  :secondaryInput="newUser.mailingAddress.streetAddress2"
                  @inputUpdated="mailingAddressUpdated"
                  :isDisabled="!isResidentDefaultAddress"
                 />
                </div>
              </div>
            </div>

            <div class="row" v-if="newUser.userType === 'INVESTOR' || newUser.userType === 'ADVISOR' || newUser.userType === 'MINOR' || newUser.userType === 'INSTITUTIONAL_REPRESENTATIVE' || newUser.userType === 'READ_ONLY'">
              <div class="col-md-3">
                <div class="form-group">
                  <label for="zip-code">Zip code <strong class="text-info">*</strong></label>

                  <input type="text" name="MailingZipcode" id="MailingZipcode" v-model="newUser.mailingAddress.zipCode" placeholder="Zip code" :class="{ 'form-control': true, 'form-control-error': isResidentDefaultAddress && (errors.has('MailingZipcode') || isZipCodeInvalid(newUser.mailingAddress.zipCode, newUser.mailingAddress.country)) }"
                    v-validate="{required: newUser.userType !== 'INSTITUTIONAL_REPRESENTATIVE' && newUser.userType !== 'READ_ONLY'}" :disabled="!isResidentDefaultAddress" />

                  <span v-if="isResidentDefaultAddress && (errors.has('MailingZipcode') || isZipCodeInvalid(newUser.mailingAddress.zipCode, newUser.mailingAddress.country))" class="error-feedback">Required</span>
                </div>
              </div>

              <div class="col-md-3">
                <div class="form-group">
                  <label for="city">City <strong class="text-info">*</strong></label>

                  <input type="text" name="MailingCity" id="MailingCity" v-model="newUser.mailingAddress.city" placeholder="City" :class="{ 'form-control': true, 'form-control-error': isResidentDefaultAddress && errors.has('MailingCity') }" v-validate="{required: newUser.userType !== 'INSTITUTIONAL_REPRESENTATIVE' && newUser.userType !== 'READ_ONLY'}"
                    :disabled="!isResidentDefaultAddress" />

                  <span v-if="isResidentDefaultAddress && errors.has('MailingCity')" class="error-feedback">Required</span>
                </div>
              </div>

              <div class="col-md-3">
                <div class="form-group">
                  <label for="pwd">State <strong class="text-info">*</strong></label>
                  <select id="MailingState" name="MailingState" v-bind:disabled="!isResidentDefaultAddress" v-model="newUser.mailingAddress.state" required v-validate="{required: newUser.userType !== 'INSTITUTIONAL_REPRESENTATIVE' && newUser.userType !== 'READ_ONLY'}" :class="{ 'form-control ': true, 'form-control-error': isResidentDefaultAddress && errors.has('MailingState'), 'disabled-state': !isResidentDefaultAddress }"
                    :disabled="!isResidentDefaultAddress">
                            <option value="" disabled selected hidden>State</option>
                            <option v-for="s in countryStates('mailingAddress')" :value="s.abbreviation">{{s.name}}</option>
                          </select>
                  <span v-if="isResidentDefaultAddress && errors.has('MailingState')" class="error-feedback">Required</span>
                </div>
              </div>
              <div class="col-md-3">
                <div class="form-group">
                  <label for="pwd">Country <strong class="text-info">*</strong></label>
                    <select id="MailingCountry" name="MailingCountry" v-model="newUser.mailingAddress.country" required :class="{ 'form-control': true, 'form-control-error': errors.has('MailingCountry') }" v-validate="{required: newUser.userType !== 'INSTITUTIONAL_REPRESENTATIVE' && newUser.userType !== 'READ_ONLY'}">
                      <option value="" disabled selected hidden>Country</option>
                      <option v-for="c in geoLocation.countries" :value="c.abbreviation">{{c.name}}</option>
                    </select>
                  <span v-if="errors.has('MailingCountry')" class="error-feedback">Required</span>
                </div>
              </div>
            </div>
            </fieldset>

            <div v-if="newUser.userType === 'INVESTOR' || newUser.userType === 'MINOR'">
              <div class="panel-title">
                <div>KYC documentation</div>
              </div>
              <div class="line-separator"></div>

              <div class="upload-container" :class="{ 'has-error': isFileInvalid }">
                <div class="bottom-margin">
                  <input @change="fileChanged" type="file" data-classbutton="btn btn-default" data-classinput="form-control inline" class="form-control filestyle" id="filestyle-0" tabindex="-1" style="position: absolute; clip: rect(0px 0px 0px 0px);" :accept="getAcceptedFileExtensions()"
                    ref="fileupload">
                  <div class="bootstrap-filestyle input-group">
                    <input type="text" class="form-control " placeholder="" disabled="" :value="selectedFile ? selectedFile.name : ''">
                    <span class="group-span-filestyle input-group-btn" tabindex="0">
                          <label for="filestyle-0" class="btn btn-default document-label">
                            <span class="icon-span-filestyle fa fa-folder-open"></span>
                    <span class="buttonText">Choose file</span>
                    </label>
                    </span>
                  </div>
                </div>
                <span class="help-block">Your file must be in JPG, JPEG, PNG, TIF or PDF format and cannot exceed 10MB.</span>
                <span v-if="isFileInvalid" class="help-block m-b-none">The file you selected is not valid. Please select a different file.</span>
              </div>
              <ul class="panel-list mt-lg text-muted">
                <li>Ensure the document has not expired.</li>
                <li>The document should not look fuzzy or cropped.</li>
                <li>Make sure the name and address match the profile information.</li>
              </ul>


              <div v-if="uploadedFiles.length > 0" class="space table-responsive">
                <table class="table table-striped table-files">
                  <thead>
                    <tr>
                      <th class="text-center">File name</th>
                      <th class="text-center">Uploaded by</th>
                      <th class="text-center">Date</th>
                      <th class="text-center">Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(file, index) in uploadedFiles">
                      <td class="text-center">{{file.name}}</td>
                      <td class="text-center">{{`${user.firstName} ${user.lastName}`}}</td>
                      <td class="text-center">{{formatDate(new Date())}}</td>
                      <td class="text-center">
                        <a class="text-red" href="#" @click.prevent="removeDocument(index)">
                          <em class="fa fa-trash"></em></a>
                      </td>
                    </tr>
                  </tbody>
                </table>
                <div class="space" />
              </div>
            </div>
            <div v-if="newUser.userType=='INVESTOR' || newUser.userType === 'MINOR'">
              <div class="panel-title space">
                <div>Payment preference</div>
              </div>
              <div class="line-separator"></div>

              <div class="row top-margin">
                <div class="col-md-6">
                  <div class="form-group">
                    <label for="pwd">Principal maturity preference <strong class="text-info">*</strong></label>
                    <select v-model="newUser.paymentPreference" name="paymentPreference" id="paymentPreference" required :class="{ 'form-control': true, 'form-control-error': errors.has('paymentPreference') }" v-validate="{required: true}">
                              <option value="" disabled selected hidden>Select principal payment preference</option>
                                <option v-for="principal in paymentPreferences" :key="principal.id" :value="principal.name">{{principal.text}}</option>
                            </select>
                    <span v-if="errors.has('paymentPreference')" class="error-feedback">Required</span>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="form-group">
                    <label for="pwd">Interest payment preference <strong class="text-info">*</strong></label>
                    <select v-model="newUser.interestPreference" name="interestPreference" id="interestPreference" required :class="{ 'form-control': true, 'form-control-error': errors.has('interestPreference') }" v-validate="{required: true}">
                              <option value="" disabled selected hidden>Select interest payment preference</option>
                                <option v-for="interest in paymentPreferences" :key="interest.id" :value="interest.name">{{interest.text}}</option>
                            </select>
                    <span v-if="errors.has('interestPreference')" class="error-feedback">Required</span>
                  </div>
                </div>
              </div>
            </div>

            <div class="line-separator top-margin"></div>

            <div class="row top-margin bottom-margin">
              <div class="col-md-2">
                <button type="submit" v-bind:disabled="disableSubmitButton()" class="btn btn-info btn-lg button-submit" v-on:click="validateAndSubmitUser()">Submit</button>
              </div>
            </div>

            <div class="line-separator"></div>
            <button type="button" class="btn-back icon-back top-margin bottom-margin" v-on:click="goBack()">Go back</button>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
  import {
    mapMutations,
    mapActions,
    mapState,
  } from 'vuex';
  import {
    SET_ERRORS_MODAL_INFO,
    SET_SUGGESTED_ADDRESS,
    SET_USER_BY_ADMIN,
    SET_SUGGESTED_ADDRESS_MODAL_VISIBLE,
    SET_SUGGESTED_ADDRESS_TYPE,
    SET_SUGGESTED_ADDRESS_YES_METHOD,
    SHOW_ERRORS_MODAL,
    SHOW_INFORMATION_MODAL,
  } from '@/store/mutation-types';

  import moment from 'moment';
  import datePicker from 'vue-bootstrap-datetimepicker';
  import addressSuggestion from '@/components/modals/AddressSuggestion';
  import errors from '@/components/modals/Errors';
  import commercialAddressOverride from '@/components/modals/CommercialAddressOverride';
  import information from '@/components/modals/Information';
  import spinner from '@/components/widgets/Spinner';
  import UserProfile from '@/entities/userProfile';
  import RestrictedTwoInputs from '@/components/formControls/RestrictedTwoInputs';
  import {
    formatDate,
    zipRegex,
  } from '@/util';
  import paymentPreferenceAction from '@/data/static/upcomingTransactionActions'; // eslint-disable-line no-unused-vars
  import ProhibitedStates from '@/data/static/reinvestProhibitedStates';
  import {
    Constants,
  } from '../data/static/constants';
  import {
    UserTypes,
  } from '../data/static/userTypes';

  const mix = {
    methods: {
      formatDate,
    },
  };

  const acceptedFileExtensions = [
    'png',
    'jpg',
    'jpeg',
    'tif',
    'pdf',
  ];

  const MAX_FILE_SIZE = 10485760;

  export default {
    name: 'UserCreationByAdmin',
    created() {
      this.loadUserProfile();
    },
    beforeMount() {
      this.loadUserProfile();
      this.loadPaymentPreference();
    },
    mixins: [mix],
    data() {
      return {
        minimumAge: 18,
        isResidentDefaultAddress: false,
        disableSubmit: false,
        newUser: null,
        uploadedFiles: [],
        isFileInvalid: false,
        uploadFailed: false,
        uploadSucceeded: false,
        selectedFile: null,
        isLoading: false,
        isBirthFieldInvalid: false,
        dateBirthConfig: {
          format: 'MM/DD/YYYY',
        },
        dateBirthFormat: 'YYYY-MM-DD',
        creationSucceeded: false,
        provideInvestorLogin: false,
        enableMfa: false,
        mfaPhonePreference: null,
        paymentPreference: [],
        ssnAvailabilityStatus: null,
        emailAvailabilityStatus: null,
        hasBeenAllowedCommercialAddress: false,
        commercialAddressOverrideComment: '',
        isCommercialOverrideModalVisible: false,
      };
    },
    watch: {
      isSuggestedAddressModalVisible(newVal) {
        if (newVal) {
          this.disableSubmit = false;
        }
      },
      async suggestedAddressModalYesCall({ suggestedAddress, addressType }) {
        if (!this.isResidentDefaultAddress) {
          this.newUser.residentialAddress = suggestedAddress;
          this.newUser.mailingAddress = suggestedAddress;
        }

        if (['residential', 'organization'].includes(addressType)) {
          this.newUser.residentialAddress = suggestedAddress;
        } else if (addressType === 'mailing') {
          this.newUser.mailingAddress = suggestedAddress;
        }
        await this.validateAndSubmitUser();
      },
      newUser: {
        handler({ paymentPreference, interestPreference, residentialAddress: { state } }) {
          if (this.isProhibitedStateSelected(state)) {
            if (paymentPreference === 'reinvest') {
              this.newUser.paymentPreference = 'payout';
            }
            if (interestPreference === 'reinvest') {
              this.newUser.interestPreference = 'payout';
            }
          }
        },
        deep: true,
      },
      provideInvestorLogin(newValue) {
        if (!newValue) {
          this.enableMfa = false;
          // Clear MFA phone preference when login is disabled
          this.mfaPhonePreference = null;
        }
      },
      enableMfa(newValue) {
        // Clear MFA phone preference when MFA is disabled
        if (!newValue) {
          this.mfaPhonePreference = null;
        }
      },
    },
    computed: {
      hasPrimaryPhone() {
        return !!this.getPhoneDigits(this.newUser.primaryPhoneNum);
      },
      hasSecondaryPhone() {
        return !!this.getPhoneDigits(this.newUser.secondaryPhoneNum);
      },
      ...mapState('errors', [
        'isVisibleErrorsModal',
      ]),
      ...mapState('app', [
        'user',
        'geoLocation',
      ]),
      ...mapState('accountCreation', [
        'isSuggestedAddressModalVisible',
        'changeAddress',
        'suggestedAddressModalYesCall',
      ]),
      ...mapState('information', [
        'isInformationModalVisible',
      ]),
      emailRequired() {
        return this.selectedUserType === 'INSTITUTIONAL_REPRESENTATIVE' || this.selectedUserType === 'READ_ONLY';
      },
      selectedUserType() {
        return (this.newUser && this.newUser.userType) || '';
      },
      isInstitutionalRepresentative() {
        return this.selectedUserType === 'INSTITUTIONAL_REPRESENTATIVE';
      },
      streetAddressLabel() {
        return `Street address${(this.selectedUserType !== 'INSTITUTIONAL_REPRESENTATIVE' && this.selectedUserType !== 'READ_ONLY') ? '*' : ''}`;
      },
      showProvideLoginOption() {
        return (
          this.newUser.userType === 'INVESTOR' ||
          this.newUser.userType === 'ADVISOR' ||
          this.newUser.userType === 'MINOR' ||
          this.newUser.userType === 'INSTITUTIONAL_REPRESENTATIVE' ||
          this.newUser.userType === 'READ_ONLY'
        );
      },
      showLoginNotice() {
        return this.newUser.userType === 'MINOR' && this.provideInvestorLogin;
      },
      emailIsInvalid() {
        return !this.newUser.email || this.errors.items.find(err => err.field === 'PrimaryEmail');
      },
      paymentPreferences() {
        return this.isProhibitedStateSelected(this.newUser.residentialAddress.state) ?
        this.paymentPreference.filter(preference => preference.name !== 'reinvest') :
        this.paymentPreference;
      },
    },
    methods: {
      ...mapActions('userCreationByAdmin', [
        'saveUserProfile',
        'provisionUser',
        'checkAvailability',
      ]),
      ...mapActions('accountCreation', [
        'updateUserDwollaProfile',
        'putDocumentToS3',
        'createAccountDocuments',
      ]),
      ...mapMutations('information', {
        showInformationModal: SHOW_INFORMATION_MODAL,
      }),
      ...mapMutations('accountCreation', {
        setSuggestedAddress: SET_SUGGESTED_ADDRESS,
        setUserByAdmin: SET_USER_BY_ADMIN,
        setSuggestedAddressType: SET_SUGGESTED_ADDRESS_TYPE,
        setSuggestedAddressModalVisible: SET_SUGGESTED_ADDRESS_MODAL_VISIBLE,
        setSuggestedAddressYesMethod: SET_SUGGESTED_ADDRESS_YES_METHOD,
      }),
      ...mapMutations('errors', {
        showErrorsModal: SHOW_ERRORS_MODAL,
        setErrorsModalInfo: SET_ERRORS_MODAL_INFO,
      }),
      loadUserProfile() {
        this.newUser = new UserProfile();
        this.newUser.userType = 'INVESTOR';
        this.newUser.interestPreference = 'reinvest';
        this.newUser.paymentPreference = 'reinvest';
        if (this.geoLocation.countries &&
          this.geoLocation.countries.length > 0) {
          this.newUser.residentialAddress.country = this.geoLocation.countries[0].abbreviation;
          this.newUser.mailingAddress.country = this.geoLocation.countries[0].abbreviation;
        }
      },
      countryStates(address) {
        if (this.newUser[address].country ===
            this.geoLocation.countries[0].abbreviation) {
          if (address !== 'mailingAddress') {
            return this.geoLocation.states.filter(state => !state.onlyMailingAddress);
          }
          return this.geoLocation.states;
        }
        return this.geoLocation.canadaStates;
      },
      loadPaymentPreference() {
        this.paymentPreference = Object.keys(paymentPreferenceAction).map(
          key => paymentPreferenceAction[key],
        );
      },
      checkDateBirth() {
        return false;
      },
      residentialAddressUpdated($event) {
        this.newUser.residentialAddress.streetAddress1 = $event.primary;
        this.newUser.residentialAddress.streetAddress2 = $event.secondary;
      },
      mailingAddressUpdated($event) {
        this.newUser.mailingAddress.streetAddress1 = $event.primary;
        this.newUser.mailingAddress.streetAddress2 = $event.secondary;
      },
      truncateAddressIfNecessary(address) {
        const localAddress = { ...address };
        const hasStreetAddress1 = Object.prototype.hasOwnProperty.call(localAddress, 'streetAddress1');
        const hasStreetAddress2 = Object.prototype.hasOwnProperty.call(localAddress, 'streetAddress2');
        if (hasStreetAddress1 && hasStreetAddress2) {
          const totalAdressLength = address.streetAddress1.length + address.streetAddress2.length;
          if (totalAdressLength > 50) {
            const charsToCut = totalAdressLength - 50;
            localAddress.streetAddress2 = address.streetAddress2.slice(0, -charsToCut);
            return localAddress;
          }
        }
        return address;
      },
      isDateBirthValid(dateOfBirth) {
        if (dateOfBirth === '') {
          return true;
        }
        const birthYear = new Date(dateOfBirth).getFullYear();
        const currentYear = new Date().getFullYear();
        return (currentYear - birthYear) >= this.minimumAge;
      },
      getAcceptedFileExtensions() {
        return acceptedFileExtensions.map(ext => `.${ext}`).join(',');
      },
      getSsnDigits(ssn) {
        return ssn.replace(/[- ]/g, '');
      },
      getCRDDigits(crd) {
        return crd.replace(/[- ]/g, '');
      },
      getPhoneDigits(phoneNum) {
        return phoneNum ? phoneNum.replace(/[-() ]/g, '') : '';
      },
      onPhoneNumberChange() {
        // Auto-clear preference if the selected phone is removed
        if (this.mfaPhonePreference === 'PRIMARY' && !this.hasPrimaryPhone) {
          this.mfaPhonePreference = null;
        }
        if (this.mfaPhonePreference === 'SECONDARY' && !this.hasSecondaryPhone) {
          this.mfaPhonePreference = null;
        }
      },
      getDateOnlyDOB(date) {
        return moment(date).format(this.dateBirthFormat).toString();
      },
      copyMailingAddress() {
        this.newUser.mailingAddress = Object.assign({}, this.newUser.residentialAddress);
      },
      isStateSelected(userProfile) {
        return userProfile.residentialAddress.state.length > 0;
      },
      validateUserProfile(userProfile) {
        const listUserErrors = [];
        if (!this.isDateBirthValid(userProfile.dateOfBirth) &&
          (userProfile.userType === 'INVESTOR' ||
          userProfile.userType === 'INSTITUTIONAL_REPRESENTATIVE')) {
          listUserErrors.push('You must be 18 years or older in order to invest with us.');
        }
        const SsnRegex = /^[0-9]{3}-?[0-9]{2}-?[0-9]{4}$/;
        if (userProfile.socialSecurityNum && !SsnRegex.test(userProfile.socialSecurityNum)) {
          listUserErrors.push('Enter a valid social security number.');
        }
        const phoneRegex = /^\(?(\d{3})\)?[- ]?(\d{3})[- ]?(\d{4})$/; // eslint-disable-line no-useless-escape
        if (!phoneRegex.test(userProfile.primaryPhoneNum)) {
          listUserErrors.push('Enter a valid primary phone number.');
        }
        if (userProfile.secondaryPhoneNum.length > 0 &&
          !phoneRegex.test(userProfile.secondaryPhoneNum)) {
          listUserErrors.push('Enter a valid secondary phone number.');
        }
        if (userProfile.userType === 'ADVISOR' || userProfile.userType === 'INVESTOR' || userProfile.userType === 'MINOR') {
          if (!zipRegex.test(userProfile.residentialAddress.zipCode)) {
            listUserErrors.push('Provide a valid residential zip code.');
          }
          if (this.isResidentDefaultAddress &&
            !zipRegex.test(userProfile.mailingAddress.zipCode)) {
            listUserErrors.push('Provide a valid mailing zip code.');
          }
          if (!this.isStateSelected(userProfile)) {
            listUserErrors.push('Please select a state in order to save your profile.');
          }
        }
        const regex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/; // eslint-disable-line no-useless-escape
        if ((userProfile.userType !== 'INVESTOR' || userProfile.userType === 'MINOR') && userProfile.email) {
          if (!regex.test(userProfile.email)) {
            listUserErrors.push('Please, enter a valid email. ');
          }
        }
        return listUserErrors;
      },
      setDataWithoutMasks() {
        this.newUser.primaryPhoneNum = this.getPhoneDigits(this.newUser.primaryPhoneNum);
        this.newUser.secondaryPhoneNum = this.getPhoneDigits(this.newUser.secondaryPhoneNum);
        this.newUser.socialSecurityNum = this.getSsnDigits(this.newUser.socialSecurityNum);
        this.newUser.dateOfBirth = this.getDateOnlyDOB(this.newUser.dateOfBirth);
        if (this.newUser.CRDnumber) {
          this.newUser.CRDnumber = this.getCRDDigits(this.newUser.CRDnumber);
        }
      },
      isProhibitedStateSelected(state) {
        return ProhibitedStates.find(s => s === state) !== undefined;
      },
      isZipCodeInvalid(zipCode) {
        if (!zipCode) {
          return false;
        }
        return !zipRegex.test(zipCode);
      },
      async validateAndSubmitUser() {
        try {
          this.disableSubmit = true;
          this.setUserByAdmin(this.newUser);
          const listUserErrors = this.validateUserProfile(this.newUser);
          if (listUserErrors.length > 0) {
            this.showUserModalsError(listUserErrors);
            this.disableSubmit = false;

            return;
          }
          if (!this.isResidentDefaultAddress) {
            this.copyMailingAddress();
          }
          this.setDataWithoutMasks();

          // Add mfaPhonePreference to newUser before saving
          this.newUser.mfaPhonePreference = this.mfaPhonePreference;

          const {
            newUser,
          } = this;
          if (
            (newUser.userType !== 'INVESTOR' &&
              newUser.userType !== 'MINOR' &&
              newUser.userType !== 'INSTITUTIONAL_REPRESENTATIVE') ||
            newUser.dateOfBirth === 'Invalid date'
          ) {
            newUser.dateOfBirth = null;
          }

          if (newUser.userType === UserTypes.INVESTOR.name) {
            const created = await this.createInvestor(newUser);
            if (created) this.goBack();
            return;
          } else if (newUser.userType === UserTypes.FINANCIAL_ADVISOR.name) {
            const created = await this.createFinancialAdvisor(newUser);
            if (created) this.goBack();
            return;
          } else if (newUser.userType === UserTypes.INSTITUTIONAL_REPRESENTATIVE.name) {
            const created = await this.createInstitutionalRepresentative(newUser);
            if (created) this.goBack();
            return;
          } else if (newUser.userType === UserTypes.READ_ONLY.name) {
            const created = await this.createReadOnly(newUser);
            if (created) this.goBack();
            return;
          } else if (newUser.userType === UserTypes.ADMIN.name) {
            const created = await this.createUserAdmin(newUser);
            if (created) this.goBack();
            return;
          }

          if (newUser.userType === 'MINOR') {
            newUser.streetAddress1 = newUser.residentialAddress.streetAddress1;
            newUser.streetAddress2 = newUser.residentialAddress.streetAddress2;
            newUser.zipCode = newUser.residentialAddress.zipCode;
            newUser.city = newUser.residentialAddress.city;
            newUser.state = newUser.residentialAddress.state;
            newUser.country = newUser.residentialAddress.country;
            newUser.mailingStreetAddress1 = newUser.mailingAddress.streetAddress1;
            newUser.mailingStreetAddress2 = newUser.mailingAddress.streetAddress2;
            newUser.mailingZipCode = newUser.mailingAddress.zipCode;
            newUser.mailingCity = newUser.mailingAddress.city;
            newUser.mailingState = newUser.mailingAddress.state;
            newUser.mailingCountry = newUser.mailingAddress.country;
            newUser.isResidentDefaultAddress = this.isResidentDefaultAddress;
          }
          await this.saveUserProfile({
            user: newUser,
            files: this.uploadedFiles,
            provideLogin: this.provideInvestorLogin,
            enableMfa: this.enableMfa,
          });

          this.creationSucceeded = true;
          this.disableSubmit = false;
          this.goBack();
          return;
        } catch (err) {
          this.disableSubmit = false;
          // Admins can override a commercial residential address via a modal
          // (re-confirmed each time, not a stored flag).
          if (err && err.errorMessage === 'RESIDENTIAL_COMMERCIAL_ADDRESS_NOT_ALLOWED') {
            this.isCommercialOverrideModalVisible = true;
          }
        }
      },
      async createFinancialAdvisor(newUser) {
        const CreateUserInvestorData = {
          firstName: newUser.firstName,
          lastName: newUser.lastName,
          email: newUser.email,
          userType: newUser.userType,
          organizationName: newUser.organizationName,
          alternateCompanyName: newUser.alternateCompanyName === '' ? null : newUser.alternateCompanyName,
          primaryPhoneNum: newUser.primaryPhoneNum,
          secondaryPhoneNum: newUser.secondaryPhoneNum === '' ? null : newUser.secondaryPhoneNum,
          mfaPhonePreference: newUser.mfaPhonePreference || this.mfaPhonePreference,
          CRDnumber: newUser.CRDnumber,
          hasBeenAllowedPOBox: false,
          mailingAddress: newUser.mailingAddress,
          businessAddress: newUser.residentialAddress,
        };

        const response = await this.provisionUser({
          user: CreateUserInvestorData,
          provideLogin: this.provideInvestorLogin,
          enableMfa: this.enableMfa,
        });

        this.disableSubmit = false;
        this.creationSucceeded = true;

        if (response.statusCode === 422) {
          return false;
        }

        return true;
      },
      async createUserAdmin(newUser) {
        const CreateUserAdminData = {
          firstName: newUser.firstName,
          lastName: newUser.lastName,
          email: newUser.email,
          userType: newUser.userType,
          primaryPhoneNum: newUser.primaryPhoneNum,
          secondaryPhoneNum: newUser.secondaryPhoneNum === '' ? null : newUser.secondaryPhoneNum,
          mfaPhonePreference: newUser.mfaPhonePreference,
        };

        const response = await this.provisionUser({
          user: CreateUserAdminData,
          provideLogin: true,
          enableMfa: true,
        });

        this.disableSubmit = false;
        this.creationSucceeded = true;

        if (response.statusCode === 422) {
          return false;
        }

        return true;
      },
      async createInstitutionalRepresentative(newUser) {
        const data = {
          firstName: newUser.firstName,
          lastName: newUser.lastName,
          email: newUser.email,
          userType: newUser.userType,
          secondaryEmail: newUser.secondaryEmail === '' ? undefined : newUser.secondaryEmail,
          primaryPhoneNum: newUser.primaryPhoneNum,
          secondaryPhoneNum: newUser.secondaryPhoneNum === '' ? undefined : newUser.secondaryPhoneNum,
          mfaPhonePreference: newUser.mfaPhonePreference,
          socialSecurityNum: newUser.socialSecurityNum ? newUser.socialSecurityNum : undefined,
          dateOfBirth: newUser.dateOfBirth ? newUser.dateOfBirth : undefined,
          hasBeenAllowedPOBox: false,
          mailingAddress: newUser.mailingAddress.streetAddress1 ? newUser.mailingAddress : undefined,
          businessAddress: (
            newUser.residentialAddress.streetAddress1 ? newUser.residentialAddress : undefined
          ),
        };

        const response = await this.provisionUser({
          user: data,
          provideLogin: this.provideInvestorLogin,
          enableMfa: this.enableMfa,
        });

        this.disableSubmit = false;
        this.creationSucceeded = true;

        if (response.statusCode === 422) {
          return false;
        }

        return true;
      },
      async createReadOnly(newUser) {
        const data = {
          firstName: newUser.firstName,
          lastName: newUser.lastName,
          email: newUser.email,
          userType: newUser.userType, // 'READ_ONLY'
          secondaryEmail: newUser.secondaryEmail === '' ? undefined : newUser.secondaryEmail,
          primaryPhoneNum: newUser.primaryPhoneNum,
          secondaryPhoneNum: newUser.secondaryPhoneNum === '' ? undefined : newUser.secondaryPhoneNum,
          socialSecurityNum: newUser.socialSecurityNum ? newUser.socialSecurityNum : undefined,
          dateOfBirth: newUser.dateOfBirth ? newUser.dateOfBirth : undefined,
          hasBeenAllowedPOBox: false,
          mailingAddress: newUser.mailingAddress.streetAddress1 ? newUser.mailingAddress : undefined,
          businessAddress: (
            newUser.residentialAddress.streetAddress1 ? newUser.residentialAddress : undefined
          ),
        };

        const response = await this.provisionUser({
          user: data,
          provideLogin: this.provideInvestorLogin,
          enableMfa: this.enableMfa,
        });

        this.disableSubmit = false;
        this.creationSucceeded = true;

        if (response.statusCode === 422) {
          return false;
        }

        return true;
      },
      async createInvestor(newUser) {
        const documentsToUpload = this.uploadedFiles.map((file) => {
          const { name, size, type } = file;

          return {
            mimetype: type,
            originalName: name,
            size,
          };
        });

        const user = {
          firstName: newUser.firstName,
          lastName: newUser.lastName,
          email: newUser.email,
          userType: newUser.userType,
          secondaryEmail: newUser.secondaryEmail === '' ? null : newUser.secondaryEmail,
          primaryPhoneNum: newUser.primaryPhoneNum,
          secondaryPhoneNum: newUser.secondaryPhoneNum === '' ? null : newUser.secondaryPhoneNum,
          mfaPhonePreference: newUser.mfaPhonePreference,
          socialSecurityNum: newUser.socialSecurityNum || null,
          dateOfBirth: newUser.dateOfBirth,
          paymentPreference: newUser.paymentPreference,
          interestPreference: newUser.interestPreference,
          documents: documentsToUpload,
          hasBeenAllowedPOBox: false,
          hasBeenAllowedCommercialAddress: this.hasBeenAllowedCommercialAddress,
          commercialAddressOverrideComment: this.hasBeenAllowedCommercialAddress
            ? this.commercialAddressOverrideComment
            : undefined,
          mailingAddress: newUser.mailingAddress,
          address: newUser.residentialAddress,
        };

        const response = await this.provisionUser({
          user,
          provideLogin: this.provideInvestorLogin,
          enableMfa: this.enableMfa,
        });

        const { accountId, documents } = response;

        if (!accountId) return false;

        let uploadedDocuments = [];

        if (documentsToUpload.length) {
          uploadedDocuments = await Promise.all(documents.map(async (doc) => {
            const file = this
                .uploadedFiles.find(f => decodeURIComponent(doc.url).includes(f.name));

            await this.putDocumentToS3({ presignedUrl: doc.url, file });
            return {
              mimetype: file.type,
              size: file.size,
              originalName: file.originalName,
              filename: doc.filename,
            };
          }));
        }

        await this.createAccountDocuments({
          accountId,
          files: { documents: uploadedDocuments },
        });

        this.disableSubmit = false;
        this.creationSucceeded = true;

        return true;
      },
      showUserModalsError(listUserErrors) {
        this.setErrorsModalInfo(listUserErrors);
        this.showErrorsModal();
      },
      goBack() {
        this.$router.push({
          name: 'Users',
        });
      },
      selectAdmin() {
        this.newUser.organizationName = Constants.companyInformation.name;
      },
      selectAdvisor() {
        this.newUser.organizationName = '';
        this.newUser.alternateCompanyName = '';
        this.newUser.CRDnumber = '';
      },
      fileChanged({
        target: {
          files,
        },
      }) {
        this.isLoading = true;
        this.isFileInvalid = false;
        if (files.length) {
          const selectedFile = files[0];
          const extension = selectedFile.name.split('.').pop().toLowerCase();
          const {
            size,
          } = selectedFile;
          if (acceptedFileExtensions.indexOf(extension) === -1 || size > MAX_FILE_SIZE) {
            this.isFileInvalid = true;
            this.selectedFile = null;
          } else {
            this.selectedFile = null;
            this.selectedFile = selectedFile;
            this.uploadedFiles.push(this.selectedFile);
          }
        }
        this.isLoading = false;
      },
      removeDocument(index) {
        if (index > -1) {
          this.uploadedFiles.splice(index, 1);
          this.selectedFile = null;
          const input = this.$refs.fileupload;
          input.type = 'text';
          input.type = 'file';
        }
      },
      submitDifferentMailingAddress() {
        this.newUser.mailingAddress.streetAddress1 = '';
        this.newUser.mailingAddress.streetAddress2 = '';
        this.newUser.mailingAddress.zipCode = '';
        this.newUser.mailingAddress.city = '';
        this.newUser.mailingAddress.state = '';
        this.newUser.mailingAddress.state = '';
      },
      confirmCommercialOverride(comment) {
        this.isCommercialOverrideModalVisible = false;
        this.hasBeenAllowedCommercialAddress = true;
        this.commercialAddressOverrideComment = comment;
        this.disableSubmit = true;
        this.createInvestor(this.newUser).then((created) => {
          if (created) this.goBack();
        });
      },
      cancelCommercialOverride() {
        this.isCommercialOverrideModalVisible = false;
        this.hasBeenAllowedCommercialAddress = false;
        this.commercialAddressOverrideComment = '';
      },
      disableSubmitButton() {
        return (
          !this.newUser.firstName ||
          !this.newUser.lastName ||
          !this.newUser.primaryPhoneNum ||
          (!this.newUser.email &&
            this.newUser.userType !== 'INVESTOR' &&
            this.newUser.userType !== 'MINOR') ||
          ((this.newUser.userType === 'ADVISOR' ||
            this.newUser.userType === 'INVESTOR' ||
            this.newUser.userType === 'MINOR') &&
            (!this.newUser.residentialAddress.streetAddress1 ||
              !this.newUser.residentialAddress.zipCode ||
              !this.newUser.residentialAddress.city ||
              !this.newUser.residentialAddress.state ||
              (this.isResidentDefaultAddress &&
                (!this.newUser.mailingAddress.streetAddress1 ||
                  !this.newUser.mailingAddress.zipCode ||
                  !this.newUser.mailingAddress.city ||
                  !this.newUser.mailingAddress.state)))) ||
          (this.newUser.userType === 'ADVISOR' && !this.newUser.organizationName) ||
          this.disableSubmit ||
          // Check for SSN validation errors
          this.errors.has('ssn') ||
          // Check for email validation errors (different field names for different user types)
          this.errors.has('Email') ||
          this.errors.has('PrimaryEmail')
        );
      },
      ssnInput() {
        // Clear SSN errors and availability status when user types
        this.$validator.errors.remove('ssn');
        this.ssnAvailabilityStatus = null;
      },
      async checkSsnAvailability() {
        // Clear any previous SSN errors first
        this.$validator.errors.remove('ssn');

        // Don't check if there are validation errors or SSN is empty
        if (this.errors.has('ssn') || !this.newUser.socialSecurityNum || this.newUser.socialSecurityNum.trim() === '') {
          this.ssnAvailabilityStatus = null;
          return;
        }

        const ssnDigits = this.getSsnDigits(this.newUser.socialSecurityNum);
        if (!ssnDigits || ssnDigits.length !== 9) {
          this.ssnAvailabilityStatus = null;
          return;
        }

        // For UserCreationByAdmin, we're always creating new users, but add safeguard just in case
        // If we're somehow editing and the SSN matches original, don't check
        if (this.newUser.id && this.newUser.originalSocialSecurityNum &&
            ssnDigits === this.newUser.originalSocialSecurityNum) {
          this.ssnAvailabilityStatus = null;
          return;
        }

        this.ssnAvailabilityStatus = 'checking';

        try {
          const response = await this.checkAvailability({ ssn: ssnDigits });
          this.ssnAvailabilityStatus = response ? 'available' : 'unavailable';

          // If SSN is not available, add validation error
          if (!response) {
            this.$validator.errors.add({
              field: 'ssn',
              msg: 'The social security number that was entered is not accepted.',
              id: 'ssn_error',
            });
          }
        } catch (error) {
          console.error('Error checking SSN availability:', error);
          this.ssnAvailabilityStatus = null;

          // Check if this is an SSN-specific error from the API
          if (error && error.message && error.message.includes('social security number')) {
            this.ssnAvailabilityStatus = 'unavailable';
            this.$validator.errors.add({
              field: 'ssn',
              msg: 'The social security number that was entered is not accepted.',
              id: 'ssn_error',
            });
          }
        }
      },
      emailInput() {
        // Clear email errors and availability status when user types
        this.$validator.errors.remove('PrimaryEmail');
        this.$validator.errors.remove('Email');
        this.emailAvailabilityStatus = null;
      },
      async checkEmailAvailability() {
        // Clear any previous email errors first
        this.$validator.errors.remove('PrimaryEmail');
        this.$validator.errors.remove('Email');

        // Don't check if there are validation errors or email is empty
        if (this.errors.has('PrimaryEmail') || this.errors.has('Email') || !this.newUser.email || this.newUser.email.trim() === '') {
          this.emailAvailabilityStatus = null;
          return;
        }

        // Basic email validation
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!emailRegex.test(this.newUser.email)) {
          this.emailAvailabilityStatus = null;
          return;
        }

        // For UserCreationByAdmin, we're always creating new users, but add safeguard just in case
        // If we're somehow editing and the email matches original, don't check
        if (this.newUser.id && this.newUser.originalEmail &&
            this.newUser.email.toLowerCase() === this.newUser.originalEmail.toLowerCase()) {
          this.emailAvailabilityStatus = null;
          return;
        }

        this.emailAvailabilityStatus = 'checking';

        try {
          const response = await this.checkAvailability({ email: this.newUser.email.toLowerCase() });
          this.emailAvailabilityStatus = response ? 'available' : 'unavailable';

          // If email is not available, add validation error
          if (!response) {
            // Determine which field name to use based on user type
            const fieldName = (this.newUser.userType === 'ADMIN' || this.newUser.userType === 'ADVISOR') ? 'Email' : 'PrimaryEmail';
            this.$validator.errors.add({
              field: fieldName,
              msg: 'An account with the given email already exists',
              id: 'email_error',
            });
          }
        } catch (error) {
          console.error('Error checking email availability:', error);
          this.emailAvailabilityStatus = null;

          // Check if this is an email-specific error from the API
          if (error && error.message && (error.message.includes('email') || error.message.includes('Email'))) {
            this.emailAvailabilityStatus = 'unavailable';
            // Determine which field name to use based on user type
            const fieldName = (this.newUser.userType === 'ADMIN' || this.newUser.userType === 'ADVISOR') ? 'Email' : 'PrimaryEmail';
            this.$validator.errors.add({
              field: fieldName,
              msg: 'An account with the given email already exists',
              id: 'email_error',
            });
          }
        }
      },
    },
    components: {
      datePicker,
      errors,
      spinner,
      information,
      RestrictedTwoInputs,
      'address-suggestion': addressSuggestion,
      'commercial-address-override': commercialAddressOverride,
    },
  };
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .message-feedback {
    background-color: #dbe9db;
    margin-left: 2%;
    margin-top: 2%;
    margin-bottom: 2%;
    width: 66%;
  }

  .birth-field-bottom {
    margin-bottom: 5px;
  }

  .button-submit {
    background-color: #127285;
  }

  .date-pick-style {
    width: 90%;
  }

  .content-wrapper {
    border-top: none;
  }

  .warning-heading {
    background-color: #f9f2ce !important;
    padding: 10px;
    margin: 0 auto 20px;
    font-size: 14px;
    font-weight: 500;
  }

  .btn-back {
    color: #31b0d5;
    background-color: Transparent;
    background-repeat: no-repeat;
    border: none;
    cursor: pointer;
    overflow: hidden;
    outline: none;
    padding-left: 20px;
  }

  .icon-back {
    position: relative;
  }

  .icon-back:before {
    content: "\f060";
    font-family: FontAwesome;
    position: absolute;
    left: 0px;
  }

  .line-separator {
    padding: 8px;
    line-height: 1.52857143;
    vertical-align: top;
    border-top: 1px solid #eee;
  }

  .left-margin {
    margin-left: 4%;
  }

  .right-margin {
    margin-right: 4%;
  }

  .top-margin {
    margin-top: 2%;
  }

  .bottom-margin {
    margin-bottom: 2%;
  }

  .space {
    margin-top: 4%;
  }

  .content-heading {
    font-weight: normal;
  }

  .upload-container {
    height: 80px;
    padding-top: 10px;
  }

  .group-span-filestyle {
    display: block;
    height: 34px;
    width: 120px;
  }

  .group-span-filestyle label {
    height: 34px;
  }

  .panel-title {
    font-size: 20px;
  }

  .panel-subtitle {
    font-size: 16px;
  }

  .panel-default {
    padding: 30px 40px;
  }

  .panel-heading {
    background-color: #ffffff;
    font-size: 16px;
    padding: 0px 5px;
  }

  .document-label {
    width: 120px;
  }

  label {
    color: #888;
    font-size: 14px;
    width: 300px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    margin-bottom: 0px;
  }

  select:required:invalid {
    color: lightgray;
  }

  option[value=""][disabled] {
    display: none;
  }

  option {
    color: black;
  }

   ::placeholder {
    /* Chrome, Firefox, Opera, Safari 10.1+ */
    color: lightgray;
    opacity: 1;
    /* Firefox */
  }

   :-ms-input-placeholder {
    /* Internet Explorer 10-11 */
    color: lightgray;
  }

   ::-ms-input-placeholder {
    /* Microsoft Edge */
    color: lightgray;
  }

  .table-files {
    width: 90%;
  }

  .disabled-state {
    color: #ccc;
  }

  .text-red {
    color: #a94442;
  }

  .radio-item {
    display: inline-block;
    position: relative;
    padding: 0 6px;
  }

  .radio-item input[type='radio'] {
    display: none;
  }

  .radio-item label {
    color: #666;
    font-weight: normal;
    cursor: pointer;
  }

  .radio-item label:before {
    content: " ";
    display: inline-block;
    position: relative;
    top: 5px;
    left: 0px;
    margin: 0 5px 0 0;
    width: 20px;
    height: 20px;
    border-radius: 11px;
    background-color: transparent;
  }

  .radio-item-repay label:before {
    left: 190px;
  }

  .radio-item-unselected label:before {
    border: 2px solid #d3d3d3;
  }

  .radio-item input[type=radio]:checked+label:after {
    border-radius: 11px;
    width: 10px;
    height: 10px;
    position: absolute;
    top: 10px;
    left: 11px;
    content: " ";
    display: block;
  }

  .radio-item-repay input[type=radio]:checked+label:after {
    left: 201px;
  }
.panel-list {
  margin-bottom: 20px;
  padding-left: 18px;
}
.panel-list li {
  margin: 6px 0;
}
fieldset {
  border-color: transparent;
}

.dark-grey-text {
  color: #888888 !important;
  font-weight: bold;
  user-select: none;
}

.account-notice {
  padding: 0;
}

.availability-check-container {
  position: relative;
}

.availability-indicator {
  position: absolute;
  right: 10px;
  top: 50%;
  transform: translateY(-50%);
  z-index: 10;
  font-size: 16px;
}

.text-success {
  color: #28a745 !important;
}

.text-danger {
  color: #dc3545 !important;
}

.text-info {
  color: #17a2b8 !important;
}
</style>



// WEBPACK FOOTER //
// UserCreationByAdmin.vue?7cc6535b